import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import './App.css';
import Header from './components/Header'; // Import the Header component
import AdminPanel from './components/AdminPanel';
import ActiveIntegrations from './components/ActiveIntegrations';
import IntegrationDetails from './components/IntegrationDetails';

function App() {
    return (
        <Router>
            <div className="App">
                <Header />
                <main className="main-content">
                    <Routes>
                        <Route path="/" element={<AdminPanel />} />
                        <Route path="/active-integrations" element={<ActiveIntegrations />} />
                        <Route path="/integration/:id" element={<IntegrationDetails />} />
                    </Routes>
                </main>
            </div>
        </Router>
    );
}

export default App;